import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconBananaBoating: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.5 15h-13C3.4 15 2 12.3 2 10.5V7c0-.3.1-.6.4-.8.3-.2.6-.2.9-.2.8.3 3 .9 3.8 1h11.4c.3 0 .6.1.8.3l2.5 3c.3.4.3.9 0 1.3l-2.5 3c-.2.3-.5.4-.8.4zm-.5-2l1.7-2L18 9h-1v4h1zM6.9 9C6.2 8.9 5 8.6 4 8.3v2.2c0 1 .9 2.5 1.5 2.5H15V9H6.9zm8.4 9.3c.5-.6 1.3-1.3 2.7-1.3 1.851 0 3.236 1.71 3.675 2.252.06.072.101.124.125.148.4.5.3 1.1-.2 1.4-.2.1-.4.2-.6.2-.3 0-.6-.1-.8-.4-.3-.4-1.3-1.6-2.2-1.6-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.4 0-2.2-.7-2.7-1.3-.5-.5-.7-.7-1.3-.7-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.851 0-3.236-1.71-3.675-2.252-.06-.073-.101-.124-.125-.148-.4-.5-.3-1.1.2-1.4.5-.4 1.1-.3 1.4.2.3.4 1.3 1.6 2.2 1.6.6 0 .8-.2 1.3-.7.5-.6 1.3-1.3 2.7-1.3 1.4 0 2.2.7 2.7 1.3.5.5.7.7 1.3.7.6 0 .8-.2 1.3-.7z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
